import styled from '@emotion/styled';

const StyledButton = styled.button``;

export { StyledButton };
